"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltProvidersCards = exports.AltProvidersHeader = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const provider_components_1 = require("@kyruus/provider-components");
const constants_1 = require("../../lib/constants");
exports.AltProvidersHeader = styled_1.default.h2 `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin: 0;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.AltProvidersCards = (0, styled_1.default)(provider_components_1.MiniProviderCardList) `
  > div {
    width: 100%;

    @media screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
      width: calc(50% - 8px);
    }
  }
`;
//# sourceMappingURL=styles.js.map